import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#97A301] group-[.toaster]:text-black group-[.toaster]:border-[#97A301] group-[.toaster]:shadow-lg group-[.toaster]:font-sans",
          description: "group-[.toast]:text-black/70",
          actionButton:
            "group-[.toast]:bg-black group-[.toast]:text-[#97A301]",
          cancelButton:
            "group-[.toast]:bg-black/20 group-[.toast]:text-black",
          success: "group-[.toaster]:bg-[#97A301] group-[.toaster]:text-black",
          error: "group-[.toaster]:bg-red-600 group-[.toaster]:text-white",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
